<template>
  <nav class="space-y-1">
    <div>
      <div class="my-5">
        <SettingsNavLinkComponent
          route-name="sa_management_home_route"
          label="home"
          icon="home"
          :collapsed="collapsed"
        />
        <SettingsNavLinkComponent
          route-name="management_release_route"
          label="Release Note"
          icon="database"
          :collapsed="collapsed"
        />
        <SettingsNavLinkComponent
          route-name="management_import_route"
          label="import"
          icon="cloud-arrow-down"
          :collapsed="collapsed"
        />
        <SettingsNavLinkComponent
          v-if="isAddfUser"
          route-name="management_commands_route"
          label="Command Runner"
          icon="command"
          :collapsed="collapsed"
        />
        <SettingsNavLinkComponent
          route-name="management_db_route"
          label="DB"
          icon="database"
          :collapsed="collapsed"
        />
        <SettingsNavLinkComponent
          route-name="playground"
          label="Playground"
          icon="database"
          :collapsed="collapsed"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingsNavLinkComponent from './SettingsNavLinkComponent'

export default {
  name: 'TheSaManagementNav',
  components: {
    SettingsNavLinkComponent
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth'
    }),
    isAddfUser() {
      return this.auth?.email?.endsWith('@addf.be') ?? false
    }
  }
}
</script>
